const apiBaseUrl = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:4000/api'
const authStorageKey = 'maintenance-report-admin-auth'

export interface AuthSession {
  token: string
  user: {
    id: string
    email: string
  }
}

export const authService = {
  async login(email: string, password: string) {
    const response = await fetch(`${apiBaseUrl}/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    })

    const payload = await response.json()

    if (!response.ok) {
      throw new Error(payload.error ?? 'Login failed')
    }

    const session = payload.data as AuthSession
    localStorage.setItem(authStorageKey, JSON.stringify(session))

    return session
  },
  getSession() {
    const rawValue = localStorage.getItem(authStorageKey)
    return rawValue ? (JSON.parse(rawValue) as AuthSession) : null
  },
  logout() {
    localStorage.removeItem(authStorageKey)
  },
}
